define('controller/people/contact.info.controller',['require','exports','module','model/contact.model','model/person.model','model/country.model','model/countrySubdivision.model','fukit/fukit','view/people/contact.detail.page.view','fukit/fukit','backbone.radio','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var ConctactModel     = require('model/contact.model'),
      PersonModel       = require('model/person.model'),
      CountryModel      = require('model/country.model'),
      SubdivisionsModel = require('model/countrySubdivision.model'),
      BaseController    = require('fukit/fukit').BaseController,
      ContactPageView   = require('view/people/contact.detail.page.view'),
      RouteHelper       = require('fukit/fukit').RouteHelper,
      Radio             = require('backbone.radio'),
      ROLES             = require('fukit/fukit').Roles;

  var USA_GUID = 'ec53619c-0393-4058-86ae-84e499fc8092';

  var ContactDetailController = BaseController.extend({
    radioRequests: {
      'controllers ContactDetailController': '@constructor',
    },

    pageView: ContactPageView,

    // stateConfiguration: {
    //   defaults: {
    //     roles: ROLES.GLOBALACCESSROLES
    //   }
    // },

    resources: {
      person: {
        model: PersonModel,
      },
      currentPersonCollection: {
        collection: PersonModel.Collection,
      },
      contact: {
        model: ConctactModel,
      },
      country: {
        model: CountryModel,
      },
      subdivision: {
        model: SubdivisionsModel,
      },
    },

    onStart: function() {
      var userPrincipalModel = Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel');
      var personModel = this.getResource('person');
      var currentPersonCollection = this.getResource('currentPersonCollection');
      var contactModel = this.getResource('contact');
      var country = this.getResource('country');
      var subdivision = this.getResource('subdivision');

      if (userPrincipalModel && userPrincipalModel.id) {
        currentPersonCollection.filters.addFilterWithField({ name: 'userAccountId' }).equals(userPrincipalModel.id);
        currentPersonCollection
          .fetch()
          .promise()
          .bind(this)
          .done(function() {
            if (currentPersonCollection.length !== 0) {
              personModel.set(currentPersonCollection.models[0].toJSON());
              if (personModel.get('contactId')) {
                contactModel.set('id', personModel.get('contactId'));
                this.setFormData(contactModel, country, subdivision);
              }
            }
          });
      }
    },

    setFormData: function(contactModel, country, subdivision) {
      contactModel
        .fetch()
        .promise()
        .done(function(contactResp) {
          if (contactResp.countryId) {
            var countrySubdivisionId = contactResp.countrySubdivisionId;

            country
              .set({ id: contactResp.countryId })
              .fetch()
              .promise()
              .done(function(countryResp) {
                subdivision.urlParams({ countryId: countryResp.id });
                if (countrySubdivisionId) {
                  subdivision.set('id', countrySubdivisionId);
                  subdivision.fetch();
                }
              });
          }
        });
    },
  });

  module.exports = ContactDetailController;
});

